import React from 'react';
import { FaUserGraduate, FaCog } from 'react-icons/fa';
import { MdDashboard } from 'react-icons/md';
import { FaPeopleLine } from 'react-icons/fa6';
import { LuNotebookPen } from 'react-icons/lu';
import HistoryIcon from '@mui/icons-material/History';
import MobileScreenShareIcon from '@mui/icons-material/MobileScreenShare';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import PaymentsIcon from '@mui/icons-material/Payments';
/**
 * Configuration for sidebar menu items
 * Each item should have:
 * - id: unique identifier
 * - route: navigation path
 * - label: display text
 * - icon: React icon component
 * - className: optional additional CSS classes
 */
export const getMenuItems = (
  userDetails = {},
  userPermissions = {},
  webServices = {},
) =>
  [
    userPermissions?.dashboard && {
      id: 'dashboard',
      route: '/dashboard',
      label: 'Dashboard',
      icon: <MdDashboard />,
    },
    userPermissions?.studentManagement && {
      id: 'students',
      route: '/students',
      label: 'Students',
      icon: <FaUserGraduate />,
    },
    userPermissions?.attendance &&
      webServices?.webAttendance && {
        id: 'attendance',
        route: '/attendence',
        label: 'Attendence',
        icon: <FaPeopleLine className='size-6' />,
      },
    userPermissions?.marks &&
      webServices?.webMarks && {
        id: 'marks',
        route: '/marks',
        label: 'Marks',
        icon: <LuNotebookPen className='size-6' />,
      },
    userPermissions?.payments && {
      id: 'payments',
      route: '/payments',
      label: 'Payments',
      icon: <PaymentsIcon className='size-6' />,
    },
    userDetails?.mobileService && {
      id: 'configurations',
      route: '/configurations',
      label: 'Configurations',
      icon: <MobileScreenShareIcon className='size-6' />,
    },
    userPermissions?.history && {
      id: 'history',
      route: '/history',
      label: 'History',
      icon: <HistoryIcon className='size-6' />,
    },
    userPermissions?.migration && {
      id: 'migration',
      route: '/migration',
      label: 'Migration',
      icon: <SwapHorizIcon className='size-6' />,
    },
    {
      id: 'settings',
      route: '/settings',
      label: 'Settings',
      icon: <FaCog />,
    },
  ].filter(Boolean);

/**
 * Sidebar dimensions and styling constants
 */
export const SIDEBAR_CONSTANTS = {
  WIDTH: 200,
  COLLAPSED_WIDTH: 64,
  TRANSITION: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  SELECTED_BACKGROUND_COLOR: '#e3edfa',
  SELECTED_COLOR: '#2563eb',
  ACTUAL_COLOR: 'white',
};
